module.exports = __webpack_public_path__ + "img/Jojo_Fixe.afc7d909.png";